module.exports = __webpack_public_path__ + "img/thumnail1.png";